// 通用文案：按钮、操作、状态、提示 —— 各工具组件高复用，统一收敛于此
export default {
  action: {
    copy: '复制',
    clear: '清空',
    sample: '示例',
    paste: '粘贴',
    download: '下载',
    upload: '上传',
    format: '格式化',
    compress: '压缩',
    validate: '校验',
    encode: '编码',
    decode: '解码',
    convert: '转换',
    generate: '生成',
    reset: '重置',
    confirm: '确定',
    cancel: '取消',
    submit: '提交',
    save: '保存',
    close: '关闭',
    swap: '交换',
    run: '运行',
    add: '添加',
    delete: '删除',
    edit: '编辑',
    search: '搜索',
    more: '更多'
  },
  status: {
    success: '成功',
    failed: '失败',
    loading: '加载中…',
    processing: '处理中…',
    empty: '暂无数据',
    copied: '已复制',
    copyFailed: '复制失败',
    noContent: '无内容',
    done: '完成'
  },
  hint: {
    quickAction: '快捷操作',
    inputPlaceholder: '请输入内容',
    charCount: '{n} 字符',
    lineCount: '{n} 行',
    requestFailed: '请求失败'
  },
  unit: {
    times: '次',
    items: '个',
    years: '岁'
  }
}
